import { Injectable } from "@angular/core";
import { ICountry } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { CountriesApiService } from "./api/countries-api.service";

@Injectable({
  providedIn: "root",
})
export class CountriesService {
  constructor(private countriesApiService: CountriesApiService) {}

  public list(code?: string): Observable<ICountry[]> {
    return this.countriesApiService.list(code);
  }
}
